// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ac00b1e4","977":"de0392eb"}[chunkId] + ".chunk.js";
};